import { render, staticRenderFns } from "./BPC_page.vue?vue&type=template&id=852a2e16&scoped=true"
import script from "./BPC_page.vue?vue&type=script&lang=js"
export * from "./BPC_page.vue?vue&type=script&lang=js"
import style0 from "./BPC_page.vue?vue&type=style&index=0&id=852a2e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852a2e16",
  null
  
)

export default component.exports